import React, { useEffect, useState }  from 'react';

import aboutThumb from '../../../assets/img/about-2-bg.jpg'
import {Link} from "react-router-dom";
import {useHomeAboutUs} from './../../../queries/homeAboutus';
import InfinitProgressBar from '../../InfiniteProgressBar';



const About = () => {


    
    const {error, loading, data} = useHomeAboutUs();
    if(loading) return <InfinitProgressBar/>
    if(error) return <div>error!</div>
   

    const buttonReadMoreStyle={
        background: 'red',
        padding: '2%',
        borderRadius: '20px',
        color: 'white',
        fontSize: '12px',
    }
    
    return (
            <div className="home-two-about-area" style={{backgroundImage:`url(${process.env.REACT_APP_BASE_URL}${data.homeAboutUs[0].aboutUsImage.urls[0]})`}}>
                <div className="container">
                    <div className="row align-items-center">
                        
    
                        <div className="col-lg-6">
                            <div className="about-content about-content--2">
                                <div style={{width:'100%', height:"80%", backgroundColor:'#fff', padding:"2%"}}>
                                    <div style={{width:'8%', height:"5px", backgroundColor:'red', position:'absolute'}}/>
                                    <br/>
                                    {/* <h6 style={{margin:"1%"}}>{aboutData.title}</h6> */}
                                    <br/>
                                    <h3>{data.homeAboutUs[0].displayText}</h3>
                                    <br/>
                                    <br/>
                                    <p dangerouslySetInnerHTML={{__html: data.homeAboutUs[0].htmlBody.html}} />
                                    {/* <Link style={buttonReadMoreStyle} to={`${process.env.PUBLIC_URL + aboutData.btnLink}`} className="btn-about">{aboutData.btnText}</Link> */}
                                    <br/>
                                    <br/>
                                    <br/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        
    );
};

export default About;
